<template>
  <div class="products-by-supplier-quick-add">
    <b-row>

      <b-col md="12" class="mb-1">
        <span class="text-muted" style="font-size:0.78rem;">
          Los campos con * son obligatorios. Es para productos que todavía no existen en el catálogo — el precio se carga después, una vez agregado al detalle.
        </span>
      </b-col>

      <b-col md="12">
        <b-form-group label="Código de barra" label-size="sm">
          <b-form-input v-model="form.barcode"
                        size="sm"
                        placeholder="Opcional"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="showCodeFields">
        <b-form-group label="Código del proveedor *" label-size="sm">
          <b-form-input v-model="form.code"
                        size="sm"
                        placeholder="Código con el que lo identifica el proveedor"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="showCodeFields">
        <b-form-group label="Código propio *" label-size="sm">
          <b-form-input v-model="form.code_system"
                        size="sm"
                        placeholder="Código interno"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="7">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name"
                        size="sm"
                        placeholder="Nombre del producto"
                        ref="inputName"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>
      <b-col md="5" v-if="enableProductShortName">
        <b-form-group label="Nombre corto" label-size="sm">
          <b-form-input v-model="form.name_short"
                        size="sm"
                        placeholder="Nombre corto"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Categoría *" label-size="sm">
          <v-select :options="categoryOptions"
                    :value="selectedCategoryOption"
                    :clearable="false"
                    :disabled="loading"
                    @input="onSelectCategory"></v-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Subcategoría *" label-size="sm">
          <v-select :options="subcategoryOptions"
                    :value="selectedSubcategoryOption"
                    :clearable="false"
                    :disabled="loading"
                    @input="onSelectSubcategory"></v-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Unidad de compra *" label-size="sm">
          <v-select :options="options.unitMeasurements"
                    v-model="form.unitPurchase"
                    placeholder="Unidad de compra"
                    :clearable="false"
                    :disabled="loading"></v-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Unidad de venta" label-size="sm">
          <v-select :options="options.unitMeasurements"
                    v-model="form.unitSale"
                    placeholder="= Unidad de compra"
                    :disabled="loading"></v-select>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="showConversion">
        <b-form-group label="Factor de conversión" label-size="sm">
          <b-form-input v-model.number="form.unit_measurement_sale_conversion"
                        type="number"
                        min="0"
                        step="0.0001"
                        size="sm"
                        :disabled="loading" />
          <small class="text-muted">1 unidad de compra = X unidades de venta</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Condición fiscal" label-size="sm">
          <v-select :options="options.ivaConditions"
                    v-model="form.ivaCondition"
                    placeholder="Condición fiscal"
                    :disabled="loading"></v-select>
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="dark" size="sm" @click="save()" :disabled="!canSave">
          <AppIcon icon="check" class="mr-1"></AppIcon>
          Guardar
        </b-button>
      </b-col>

    </b-row>

    <b-modal v-model="modal.category"
             centered
             size="md"
             :title="categoryModalTitle"
             ok-title="Guardar"
             cancel-title="Cancelar"
             ok-variant="dark"
             @ok="saveNewCategory">
      <b-form-group :label="modal.categoryType === 'category' ? 'Nombre de la categoría' : 'Nombre de la subcategoría'">
        <b-form-input v-model="newCategoryName" autofocus @keyup.enter.native="saveNewCategory" />
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
  import costsServiceAPI from '@/components/inc/productPricing/services'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import Error from '@/handler/error'

  const emptyForm = () => ({
    name: '',
    name_short: '',
    barcode: '',
    code: '',
    code_system: '',
    category: '',
    subcategory: '',
    unitPurchase: null,
    unitSale: null,
    unit_measurement_sale_conversion: 1,
    ivaCondition: null,
  })

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
      extraFilterData: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        form: emptyForm(),
        loading: false,
        options: {
          categories: [],
          unitMeasurements: [],
          ivaConditions: [],
        },
        modal: {
          category: false,
          categoryType: 'category',
        },
        newCategoryName: '',
      }
    },
    computed: {
      enableProductShortName() {
        return Helper.hasParametersAccess(Param.P76)
      },
      showCodeFields() {
        return !this.form.barcode
      },
      showConversion() {
        return !!(this.form.unitPurchase && this.form.unitSale && this.form.unitPurchase.value !== this.form.unitSale.value)
      },
      suppliersId() {
        return this.extraFilterData ? this.extraFilterData.suppliers_id : 0
      },
      categoryModalTitle() {
        return this.modal.categoryType === 'category' ? 'Nueva categoría' : 'Nueva subcategoría'
      },
      // Igual lógica que crudProductSuppliersByBarcode.vue: opciones por nombre (no por id) para
      // poder "crear nueva" sin pegarle al backend — el alta real ocurre recién al guardar el
      // producto, vía find-or-create por nombre (setCategoryImport en costsSuppliersProductsConvert).
      categoryOptions() {
        var items = this.options.categories.map((item) => ({ value: item.name, label: item.name }))
        if(this.form.category && !this.options.categories.some((item) => item.name === this.form.category)) {
          items.push({ value: this.form.category, label: this.form.category })
        }
        items.push({ value: '__new__', label: 'Crear nueva categoría...' })
        return items
      },
      subcategoryOptions() {
        var category = this.options.categories.find((item) => item.name === this.form.category)
        var items = (category && category.subcategorys ? category.subcategorys : []).map((item) => ({ value: item.name, label: item.name }))
        if(this.form.subcategory && !items.some((item) => item.value === this.form.subcategory)) {
          items.push({ value: this.form.subcategory, label: this.form.subcategory })
        }
        items.push({ value: '__new__', label: 'Crear nueva subcategoría...' })
        return items
      },
      selectedCategoryOption() {
        return this.categoryOptions.find((item) => item.value === this.form.category) || null
      },
      selectedSubcategoryOption() {
        return this.subcategoryOptions.find((item) => item.value === this.form.subcategory) || null
      },
      canSave() {
        if(this.loading || !this.suppliersId) return false
        if(!this.form.name.trim()) return false
        if(!this.form.category || !this.form.subcategory) return false
        if(!this.form.unitPurchase) return false
        if(this.form.barcode) return true
        return !!(this.form.code.trim() && this.form.code_system.trim())
      },
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if(val) {
            // La fila viene de products/find/control/controlByFilterBySupplier, que ya trae
            // costs_suppliers_products_id/supplier_code, Subcategory.Category y UnitMeasurementPurchase
            // precargados — no hace falta pegarle a otro endpoint para editar.
            var subcat = val.subcategory || val.Subcategory || null
            var cat = subcat ? (subcat.category || subcat.Category || null) : null
            var unit = val.unit_measurement_purchase || val.UnitMeasurementPurchase || null
            var unitOption = unit ? { value: unit.id, label: this.unitLabel(unit) } : null
            this.form = {
              name: val.name || '',
              name_short: val.name_short || '',
              barcode: val.barcode || '',
              code: val.supplier_code || '',
              code_system: val.code || '',
              category: cat ? cat.name : '',
              subcategory: subcat ? subcat.name : '',
              unitPurchase: unitOption,
              unitSale: unitOption,
              unit_measurement_sale_conversion: 1,
              ivaCondition: null,
            }
          } else {
            this.form = emptyForm()
          }
        },
      },
    },
    mounted() {
      this.loadOptions()
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      unitLabel(unit) {
        return unit.name + (unit.reference ? ' (' + unit.reference + ')' : '')
      },
      loadOptions() {
        // Mismo endpoint bundle que usa crudProductSuppliersByBarcode.vue: categorías (con
        // subcategorías anidadas) + unidades de medida en un solo viaje.
        costsServiceAPI.obtenerOpcionesProductoCostosPorCodigoBarras().then((r) => {
          var data = r.data || {}
          this.options.categories = data.categories || []
          this.options.unitMeasurements = (data.unit_measurements || []).map((unit) => ({ value: unit.id, label: this.unitLabel(unit), raw: unit }))
          this.applyUnitDefault()
        })
        costsServiceAPI.obtenerCondicionesIva().then((r) => {
          this.options.ivaConditions = (r.data || []).map((cond) => ({ value: cond.id, label: cond.name }))
          this.applyIvaDefault()
        }).catch(() => {})
      },
      // Mismo criterio que getDefaultUnitId()/getDefaultIvaConditionId() en
      // crudProductSuppliersByBarcode.vue: "Unidad"/"UN" por default en compra y venta, y la
      // condición fiscal que contenga "21" (21%). No pisa un valor ya cargado (edición o tipeo previo).
      applyUnitDefault() {
        if(this.form.unitPurchase) return
        var unit = this.options.unitMeasurements.find((opt) => {
          var name = (opt.raw.name || '').toString().toLowerCase()
          var reference = (opt.raw.reference || '').toString().toLowerCase()
          return name === 'unidad' || reference === 'unidad' || reference === 'un'
        }) || this.options.unitMeasurements[0] || null
        if(unit) {
          this.form.unitPurchase = unit
          this.form.unitSale = unit
        }
      },
      applyIvaDefault() {
        if(this.form.ivaCondition) return
        var iva = this.options.ivaConditions.find((opt) => opt.label.indexOf('21') !== -1) || null
        if(iva) this.form.ivaCondition = iva
      },
      onSelectCategory(option) {
        if(!option) return
        if(option.value === '__new__') {
          this.modal.categoryType = 'category'
          this.newCategoryName = ''
          this.modal.category = true
          return
        }
        this.form.category = option.value
        this.form.subcategory = ''
      },
      onSelectSubcategory(option) {
        if(!option) return
        if(option.value === '__new__') {
          this.modal.categoryType = 'subcategory'
          this.newCategoryName = ''
          this.modal.category = true
          return
        }
        this.form.subcategory = option.value
      },
      saveNewCategory(event) {
        var name = this.newCategoryName.trim()
        if(!name) {
          if(event) event.preventDefault()
          return
        }

        if(this.modal.categoryType === 'category') {
          this.form.category = name
          this.form.subcategory = ''
          if(!this.options.categories.some((item) => item.name === name)) {
            this.options.categories.push({ id: 0, name: name, subcategorys: [] })
          }
        } else {
          this.form.subcategory = name
          var category = this.options.categories.find((item) => item.name === this.form.category)
          if(category) {
            if(!category.subcategorys) category.subcategorys = []
            if(!category.subcategorys.some((item) => item.name === name)) {
              category.subcategorys.push({ id: 0, name: name })
            }
          }
        }

        this.modal.category = false
      },
      save() {
        if(!this.canSave) return
        this.loading = true

        // Misma lógica que validateForm() en crudProductSuppliersByBarcode.vue: si hay código de
        // barra, code/code_system se derivan de ahí (por eso esos dos campos se ocultan).
        if(this.form.barcode) {
          this.form.code = this.form.barcode
          this.form.code_system = this.form.barcode
        }

        var isEdit = !!(this.item && this.item.id && this.item.costs_suppliers_products_id)
        var purchaseUnitId = this.form.unitPurchase ? this.form.unitPurchase.value : 0
        var saleUnitId = this.form.unitSale ? this.form.unitSale.value : purchaseUnitId
        var conversion = saleUnitId === purchaseUnitId ? 1 : (this.form.unit_measurement_sale_conversion || 1)
        var name = this.form.name.trim()

        var payload = {
          type: isEdit ? 'EDITAR' : 'NUEVO',
          id: isEdit ? this.item.costs_suppliers_products_id : 0,
          products_id: isEdit ? this.item.id : 0,
          suppliers_id: this.suppliersId,
          code: this.form.code.trim(),
          code_system: this.form.code_system.trim(),
          barcode: this.form.barcode ? this.form.barcode.trim() : '',
          name: name,
          name_short: (this.enableProductShortName && this.form.name_short.trim()) ? this.form.name_short.trim() : name,
          category: this.form.category,
          subcategory: this.form.subcategory,
          line: '',
          subline: '',
          depth: 0,
          long: 0,
          height: 0,
          weight: 0,
          unit_measurement_purchase_id: purchaseUnitId,
          unit_measurement_sale_id: saleUnitId,
          unit_measurement_sale_conversion: conversion,
          iva_condition_id: this.form.ivaCondition ? this.form.ivaCondition.value : 0,
          lists: [],
          price_list: 0,
          percentage_discount: 0,
          percentage_discount_1: 0,
          percentage_discount_2: 0,
          additional: 0,
          additional_1: 0,
          additional_percentage: 0,
          additional_percentage_1: 0,
          skip_supplier_price_update: true,
          edit_source: 'purchaseRemitsProductsBySupplier',
          staff_id: Helper.getStaffId(),
        }

        costsServiceAPI.vincularProductoProveedor(payload)
          .then((r) => {
            this.$awn.success(isEdit ? 'Producto actualizado' : 'Producto creado y vinculado al proveedor')
            this.$emit('saved', r.data)
          })
          .catch((error) => { this.$awn.alert(Error.showError(error)) })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
<style>
  /* Mismo criterio que _list-views.scss: v-select no mide igual que un
     .form-control size="sm" por defecto — se fuerza fondo blanco y el
     mismo alto (31px) para que no se distinga del resto de los inputs.
     !important porque vue-select.css trae "background:none" en el propio
     selector .vs__dropdown-toggle. */
  .products-by-supplier-quick-add .v-select,
  .products-by-supplier-quick-add .vs__dropdown-toggle,
  .products-by-supplier-quick-add .vs__search {
    background-color: #fff !important;
  }
  .products-by-supplier-quick-add .vs__dropdown-toggle {
    min-height: 31px;
    padding: 0 0 2px;
  }
  .products-by-supplier-quick-add .vs__selected-options {
    padding: 0 2px;
  }
  .products-by-supplier-quick-add .vs__search,
  .products-by-supplier-quick-add .vs__selected {
    margin-top: 2px;
    font-size: var(--app-text-sm);
  }
  .products-by-supplier-quick-add .vs__actions {
    padding-top: 2px;
  }
</style>
